import * as React from 'react';
import premiumIcon from './assets/premium.svg';
import { GenericService } from '../GenericService';
import { IServiceComponentProps } from '../ServiceContainer/types';
import { ServicePrice } from '../../ServicePrice';

export const PremiumService = ({
  formattedPrice,
  isSelected,
  onClick,
  title,
  subtitle,
  description,
}: IServiceComponentProps) => {
  return (
    <GenericService
      title={title}
      subtitle={subtitle}
      description={description}
      dataName="PremiumService"
      bgColor="white"
      checked={isSelected}
      onClick={onClick}
      icon={<img src={premiumIcon} />}
    >
      <ServicePrice price={formattedPrice} />
    </GenericService>
  );
};
